import RefNavbar from './RefNavbar';
import RefSecurity from './RefSecurity';

function Page2026Security() {
  return (
    <>
      <RefNavbar />
      <RefSecurity />
    </>
  );
}

export default Page2026Security;
